/**
 *
 *
 * @depend https://github.com/Hacker0x01/react-datepicker/
 */
import React, { useCallback } from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ja } from 'date-fns/locale';
import dayjs from 'dayjs';

registerLocale('ja', ja);

type Props = {
  date: Date;
  onMonthChange?: (date: Date) => void;
  onDateChange: (date: Date) => void;
  selectableDays: string[];
};

export const InlineDatePicker = ({ ...props }: Props) => {
  const { date, onDateChange, onMonthChange, selectableDays } = props;

  const getDayClassName = useCallback(
    (v: Date) => (selectableDays.includes(dayjs(v).format('YYYY-MM-DD')) ? null : 'is-notActive'),
    [selectableDays],
  );

  return (
    <Styled>
      <DatePicker
        selected={date}
        onChange={onDateChange}
        locale="ja"
        inline
        onMonthChange={onMonthChange}
        dayClassName={getDayClassName}
      />
    </Styled>
  );
};

const Styled = styled.div`
  background: #fff;
  width: 100%;
  font-size: 0;
  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker {
    width: 100%;
    font-family: 'Noto Sans JP', sans-serif;
    font-size: 1rem;
    .is-notActive {
      background: ${StyleConfig.COLOR.BTN_DISABLED};
      pointer-events: none;
      cursor: not-allowed;
    }
  }
  .react-datepicker__month-container {
    width: 100%;
  }
  .react-datepicker__day--selected {
    background-color: ${StyleConfig.COLOR.PRIMARY};
  }
  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    width: calc(100% / 7);
    margin: 0 auto;
    line-height: 3.5rem;
  }
`;

export default InlineDatePicker;
